import metadata from "./../../block.json";
import Save from "./../../Save";

const v1 = {
	attributes: {
		...metadata.attributes,
		orientation: {
			type: "object",
		},
		justification: {
			type: "object",
		},
		alignment: {
			type: "object",
		},
		blockPadding: {
			type: "object",
			default: {
				dimension: 1,
				desktop: {
					left: 15,
					right: 15,
					unit: "px",
				},
			},
			style: [
				{
					selector: "{{WRAPPER}} { padding: {{VALUE}}; }",
				},
			],
		},
	},
	supports: metadata.supports,
	save: Save,
};

export default v1;
